module.exports = {
	"type": "object",
	"required": [
		"log"
	],
	"properties": {
		"log": {
			"$ref": "#log"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/har-validator/lib/schemas/har.json
// module id = 144
// module chunks = 0 1